import React from "react";
import IncomeAttributeLookupObject from "../../../types/lookups/IncomeAttributeLookupObject";
import IncomeAttributeTableFragmentGenerator from "../../../utils/TableGenerator/IncomeAttributeTableFragmentGenerator";
import { ProfileOverviewState } from "../../../redux/reducers/getProfile/getProfileOverviewReducer";
import { useSelector } from "react-redux";
import { selectProfileGetOverview } from "../../../redux/selectors/exportSelectorPaths";
import { useTranslation } from "react-i18next";

export interface ExpenseTabProps {
  handleTotalExpense: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
  handleCommentChange: (value: string, name: string) => void,
  lookups: IncomeAttributeLookupObject[],
  incomeAttributes?: Record<string, unknown>[],
}

export default function ExpenseTab(props: ExpenseTabProps): JSX.Element {
  const profileOverview: ProfileOverviewState = useSelector(selectProfileGetOverview);
  const profileType = profileOverview.profile.profile_type_code;
  const { t } = useTranslation("pie");
  return (
    <>
      {
        props.lookups &&
        <table className="table-with-border pie-table accordion-content" role="presentation">
          <thead>
            <tr>
              <th id="attribute-label" scope="col"></th>
              <th id="attribute-value" scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {
              props.lookups.map((attr, key) => {
                let incomeAttributesData: Record<string, unknown> | undefined = undefined;
                if (props.incomeAttributes) {
                  incomeAttributesData = props.incomeAttributes.find(({ code }) => code === attr.incomeAttributeCode);
                }
                if (["52", "62", "65", "69", "75", "77", "84", "87"].includes(attr.incomeAttributeCode)) {
                  return <IncomeAttributeTableFragmentGenerator
                    key={key} 
                    attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} 
                    hasInputLabel={true} 
                    isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    valueChangeHandler={props.handleTotalExpense} 
                    isRequiredField={false}
                    tooltip={t('tooltip.shared.otherExpense')} />
                } else if (attr.incomeAttributeCode === '54' || attr.incomeAttributeCode === '49') {
                  return <IncomeAttributeTableFragmentGenerator 
                    key={key} 
                    attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} 
                    hasInputLabel={false} 
                    isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    valueChangeHandler={props.handleTotalExpense} 
                    isRequiredField={true} />
                } else if (attr.incomeAttributeCode === '24' && profileType === "HTL") {
                  return <IncomeAttributeTableFragmentGenerator 
                    key={key} 
                    attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} 
                    hasInputLabel={false} 
                    isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    valueChangeHandler={props.handleTotalExpense} 
                    isRequiredField={false} 
                    hideTooltip={true} />
                } else {
                  return <IncomeAttributeTableFragmentGenerator 
                    key={key} 
                    attribute={attr}
                    data={incomeAttributesData}
                    showSubheading={false} 
                    hasInputLabel={false} 
                    isOtherLabel={false}
                    handleCommentChange={props.handleCommentChange}
                    valueChangeHandler={props.handleTotalExpense} 
                    isRequiredField={false} />
                }
              }
              )
            }
          </tbody>
        </table>
      }
    </>
  );
}
